import { Link } from 'react-router-dom';
import coverImage from '../static/images/shop_cover_image.jpg'
import { useTranslation } from "react-i18next";

const ShopSection = () => {
    const {t} = useTranslation();
    return (
        <div className="w-full lg:w-[1000px] flex gap-4 mt-16 mb-8 flex-col md:flex-row justify-center">
            {/* Copy */}
            <div className="flex-1 w-full flex flex-col items-start md:items-center justify-center">
                <h1 className="text-[#225424]">{t('Homepage.ShopSection.supportUs')}</h1>
                <h3 className="text-start md:text-center">{t('Homepage.ShopSection.buyMerchandisingFirst')}</h3>
                <h3 className="text-start md:text-center">{t('Homepage.ShopSection.buyMerchandisingSecond')}</h3>
                <Link to="/shop"><button className="bg-[#225424] py-2 px-3 rounded-xl text-white mt-4">{t('Homepage.ShopSection.visitOurShopButton')}</button></Link>
            </div>
            {/* Gallery */}
                <div className="flex-1 w-full rounded-xl overflow-hidden cursor-pointer">
                    <img src={coverImage} className='h-full w-full object-cover' />
                </div>

        </div>
    )
}

export default ShopSection;